var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-mask" },
    [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          { staticClass: "scroll-box" },
          [
            _c(
              "v-container",
              { staticClass: "modal-container" },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      [
                        _c("h1", [_vm._v("Transação")]),
                        _vm.loading
                          ? _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "justify-center align-center"
                                  },
                                  [
                                    _c("v-progress-circular", {
                                      attrs: {
                                        size: 35,
                                        color: "primary",
                                        indeterminate: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-row",
                          { staticClass: "top-row" },
                          [
                            _c("v-col", [
                              _vm._v(
                                "Neg.: " +
                                  _vm._s(_vm.formatDate(_vm.source.tradeDate))
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Data: " +
                                  _vm._s(_vm.formatDate(_vm.source.date))
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v("Quant.: " + _vm._s(_vm.source.quantity))
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "Valor: " +
                                  _vm._s(
                                    _vm.currencyHelper.formatValue(
                                      _vm.source.value
                                    )
                                  )
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _vm._v(
                                "Total: " +
                                  _vm._s(
                                    _vm.currencyHelper.formatValue(
                                      _vm.source.amount
                                    )
                                  )
                              )
                            ]),
                            _c("v-col", [
                              _vm._v("Tipo: " + _vm._s(_vm.source.type))
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "bottom-row" },
                          [
                            _c("v-col", [
                              _vm._v(
                                "Descr.: " + _vm._s(_vm.source.description)
                              )
                            ]),
                            _c("v-col", [
                              _vm._v(
                                "N. corr.: " +
                                  _vm._s(_vm.source.brokerageNumber)
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _c("label", [
                                _c("input", {
                                  attrs: {
                                    type: "checkbox",
                                    title:
                                      "Status de seleção para adição ao Kristal",
                                    disabled: _vm.loading
                                  },
                                  domProps: {
                                    checked:
                                      _vm.source && _vm.source.import
                                        ? "checked"
                                        : ""
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.tgStatus($event)
                                    }
                                  }
                                }),
                                _vm._v(" Selecionada para adição ao Kristal ")
                              ])
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "v-btn",
        {
          staticClass: "close-btn",
          attrs: { icon: "", disabled: _vm.loading },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c("img", {
            staticClass: "icon",
            attrs: {
              src: require("@/assets/icons/close.svg"),
              alt: "dashboard"
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }